import { render, staticRenderFns } from "./InputId.vue?vue&type=template&id=06ba2c96&"
import script from "./InputId.vue?vue&type=script&lang=ts&"
export * from "./InputId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports